import React from 'react';

const DampakSosialInovasiPelajar: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Teknologi terbaik bukanlah teknologi yang paling rumit atau paling mahal, melainkan teknologi yang mampu memecahkan masalah nyata dan meningkatkan kualitas hidup masyarakat di sekitarnya. Sepanjang penyelenggaraan <b>Indonesia Innovative Technology (IIT) Challenge</b>, kita menyaksikan bagaimana ide-ide segar dari pelajar sekolah dan mahasiswa mampu melahirkan inovasi yang menyentuh hati dan berdampak nyata.
      </p>

      <p className="mb-4">
        Mulai dari game edukasi ramah anak yang mengajarkan toleransi, sistem website desa yang mendongkrak penjualan produk pengrajin lokal, hingga perangkat sensor pintar yang mendeteksi pencemaran air dan ancaman longsor di daerah terpencil—seluruh karya ini membuktikan bahwa batas usia bukanlah penghalang untuk menghadirkan perubahan positif.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Tiga Nilai Luhur Inovator Muda Indonesia
      </h2>
      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Empati Sosial yang Kuat:</strong> Memulai penciptaan karya bukan dari sekadar ingin pamer teknologi canggih, melainkan dari kepedulian mendalam terhadap kesulitan yang dialami tetangga dan lingkungan sekitar.
        </li>
        <li>
          <strong>Ketangguhan Menyikapi Kegagalan:</strong> Memandang error kode dan kerusakan komponen elektronik bukan sebagai akhir, melainkan sebagai proses pembelajaran berharga untuk menyempurnakan solusi.
        </li>
        <li>
          <strong>Semangat Berbagi Pengetahuan:</strong> Terbuka membagikan inspirasi, kode sumber, dan dokumentasi proyek agar dapat dipelajari dan dikembangkan lebih lanjut oleh komunitas.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Menuju Indonesia Maju Berbasis Inovasi
      </h2>
      <p className="mb-4">
        Semangat berinovasi yang terus berkobar di dada generasi muda adalah modal terbesar bangsa ini dalam melangkah maju. Melalui dedikasi, kerja keras, dan kepedulian sosial, masa depan Indonesia berada di tangan yang tepat.
      </p>
    </div>
  );
};

export default DampakSosialInovasiPelajar;
